import './BetbookPostDetailHeader.less';

import clsx from 'clsx';
import React from 'react';

import { BackButton, LeftIconButton } from '@/common/components/HelperButtons';
import { useSticky } from '@/_hooks/useSticky';

function BetbookDetailHeaderSimplified({ title }) {
    const [isSticky, stickyRef] = useSticky();

    return (
        <>
            <div
                className={clsx('betbook-header bg-light-burgundy br-b-default-light', { fixed: isSticky })}
                ref={stickyRef}
            >
                <div className="betbook-header-info">
                    <div className="betbook-header-back-button">
                        <BackButton className="" button={<LeftIconButton />} />
                    </div>
                    <div className="betbook-header-title">{title}</div>
                </div>
            </div>
            {isSticky ? <div className="betbook-post-header-sticky-placeholder" /> : null}
        </>
    );
}

export default BetbookDetailHeaderSimplified;
